import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-botao-denuncias',
  templateUrl: './botao-denuncias.component.html',
  styleUrls: ['./botao-denuncias.component.css']
})
export class BotaoDenunciasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
